import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { IApiResponse } from '@web/shared-types';
import {
  IOperatorDropDown,
  IOperatorMapping,
  OperatorMappingId,
} from '@web/dtos';
import { firstValueFrom } from 'rxjs';
import { OperatorMappingGateway } from './operator-mapping-gateway';

@Injectable({ providedIn: 'root' })
export class OperatorMappingStore {
  private readonly gateway: OperatorMappingGateway =
    new OperatorMappingGateway();

  #operatorMappingsResource: ResourceRef<
    IApiResponse<IOperatorMapping[]> | undefined
  > = resource({
    loader: (): Promise<IApiResponse<IOperatorMapping[]>> => {
      return firstValueFrom(this.gateway.get());
    },
  });
  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#operatorMappingsResource.isLoading()
  );
  readonly operatorMappings: Signal<IOperatorMapping[]> = computed(() => {
    if (this.#operatorMappingsResource.hasValue()) {
      const data: IOperatorMapping[] = this.#operatorMappingsResource.value()
        ?.data as unknown as IOperatorMapping[];
      return data ?? [];
    }
    return [];
  });

  saveMapping(mapping: IOperatorMapping): void {
    if (!mapping.id) {
      delete mapping.id;
    }
    mapping.dropDownOptions.map((option: IOperatorDropDown) => {
      if (!option.id) {
        delete option.id;
      }
    });
    firstValueFrom(this.gateway.save([mapping])).then(() => this.reload());
  }

  saveMappings(mappings: IOperatorMapping[]): void {
    firstValueFrom(
      this.gateway.save(
        mappings.map((mapping: IOperatorMapping) => {
          if (!mapping.id) {
            delete mapping.id;
          }
          mapping.dropDownOptions.map((option: IOperatorDropDown) => {
            if (!option.id) {
              delete option.id;
            }
          });
          return mapping;
        })
      )
    ).then(() => this.reload());
  }

  deleteMapping(id: OperatorMappingId): void {
    firstValueFrom(this.gateway.delete(id)).then(() => this.reload());
  }

  reload(): void {
    this.#operatorMappingsResource.reload();
  }
}
